import CryptoJS from "crypto-js";
import logging from "app/shared/utils/logging";

const { AES, enc} = CryptoJS;
// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
const KEY = `${process.env.REACT_APP_ENCRYPTION_KEY}`;
// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
const URI_KEY = `${process.env.REACT_APP_ENCRYPT_URI_KEY}`;

const ENABLE_ENCRYPT = (process.env.REACT_APP_ENABLE_ENCRYPT !== "false");

export const encrypt = (data: string): string => {
    if (ENABLE_ENCRYPT) {
        try {
            return AES.encrypt(data, KEY).toString();
        } catch (e) {
            logging.debug("_ENCRYPT_ERR", `Encryption Failed`, e);
        }
    }
    return data;
};

export const decrypt = (encryptedData: string): string => {
    if (ENABLE_ENCRYPT) {
        try {
            return AES.decrypt(encryptedData.toString(), KEY).toString(enc.Utf8);
        } catch (e) {
            logging.debug("_ENCRYPT_ERR", `Decryption Failed`, e);
        }
    }
    return encryptedData;
};

// TODO: Bypass to read the shell injected localstorage value using URI Key.
// Need cleanup after 11/11 release mobile should use the Body Encryption Key instead URI Key.
export function decryptShellValue(cipherText:string) {
    if (ENABLE_ENCRYPT) {
        try {
            if (cipherText) {
                const reb64 = enc.Hex.parse(cipherText);
                const bytes = reb64.toString(enc.Base64);
                const decryptedText = AES.decrypt(bytes, URI_KEY);
                return decryptedText.toString(enc.Utf8);
            }
        } catch (e) {
            logging.debug("_Decrypt_ERR", `Decryption Failed`, e);
        }
    }
    return cipherText;
}

export const getKey = (key: string) => {
    try {
        const val = window.sessionStorage.getItem(key);
        if (ENABLE_ENCRYPT) {
            return (val) ? decrypt(val) : null;
        }
        return val || null;
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const setKey = (key: string, value: string) => {
    try {
        if (ENABLE_ENCRYPT) {
            const encryptVal = encrypt(value);
            window.sessionStorage.setItem(key, encryptVal);
        } else {
            window.sessionStorage.setItem(key, value);
        }
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const getKeyPersist = (key: string) => {
    try {
        const val = window.localStorage.getItem(key);
        if (ENABLE_ENCRYPT) {
            return (val) ? decrypt(val) : null;
        }
        return val || null;
    } catch (e) {
        logging.debug("_ENCRYPT_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const setKeyPersist = (key: string, value: string) => {
    try {
        if (ENABLE_ENCRYPT) {
            const encryptVal = encrypt(value);
            window.localStorage.setItem(key, encryptVal);
        } else {
            window.localStorage.setItem(key, value);
        }
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const deleteKeyPersist = (key: string) => {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};

export const deleteKey = (key: string) => {
    try {
        window.sessionStorage.removeItem(key);
    } catch (e) {
        logging.debug("_ENCRYPT_PERSIST_ERR", `Issue getting value for key${key}`, e);
    }
    return null;
};
